/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * MembershipsApi - axios parameter creator
 * @export
 */
export const MembershipsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateMembershipDto} createMembershipDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerCreate: (createMembershipDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createMembershipDto' is not null or undefined
            assertParamExists('membershipControllerCreate', 'createMembershipDto', createMembershipDto);
            const localVarPath = `/membership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createMembershipDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [memberId]
         * @param {'nonMember' | 'currentMember' | 'inactiveMember' | 'removedMember' | 'resignedMember' | 'inReview' | 'pendingApproval' | 'rejected' | 'awaitingUpdate' | 'applicationSent'} [membershipStatus]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerFindAll: (memberId, membershipStatus, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/membership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }
            if (membershipStatus !== undefined) {
                localVarQueryParameter['membershipStatus'] = membershipStatus;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('membershipControllerFindOne', 'id', id);
            const localVarPath = `/membership/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerRemove: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('membershipControllerRemove', 'id', id);
            const localVarPath = `/membership/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {UpdateMembershipDto} updateMembershipDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerUpdate: (id, updateMembershipDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('membershipControllerUpdate', 'id', id);
            // verify required parameter 'updateMembershipDto' is not null or undefined
            assertParamExists('membershipControllerUpdate', 'updateMembershipDto', updateMembershipDto);
            const localVarPath = `/membership/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateMembershipDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MembershipsApi - functional programming interface
 * @export
 */
export const MembershipsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MembershipsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateMembershipDto} createMembershipDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerCreate(createMembershipDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.membershipControllerCreate(createMembershipDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [memberId]
         * @param {'nonMember' | 'currentMember' | 'inactiveMember' | 'removedMember' | 'resignedMember' | 'inReview' | 'pendingApproval' | 'rejected' | 'awaitingUpdate' | 'applicationSent'} [membershipStatus]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerFindAll(memberId, membershipStatus, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.membershipControllerFindAll(memberId, membershipStatus, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.membershipControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerRemove(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.membershipControllerRemove(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {UpdateMembershipDto} updateMembershipDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerUpdate(id, updateMembershipDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.membershipControllerUpdate(id, updateMembershipDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MembershipsApi - factory interface
 * @export
 */
export const MembershipsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MembershipsApiFp(configuration);
    return {
        /**
         *
         * @param {CreateMembershipDto} createMembershipDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerCreate(createMembershipDto, options) {
            return localVarFp
                .membershipControllerCreate(createMembershipDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [memberId]
         * @param {'nonMember' | 'currentMember' | 'inactiveMember' | 'removedMember' | 'resignedMember' | 'inReview' | 'pendingApproval' | 'rejected' | 'awaitingUpdate' | 'applicationSent'} [membershipStatus]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerFindAll(memberId, membershipStatus, page, pageSize, sortBy, options) {
            return localVarFp
                .membershipControllerFindAll(memberId, membershipStatus, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerFindOne(id, options) {
            return localVarFp
                .membershipControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerRemove(id, options) {
            return localVarFp
                .membershipControllerRemove(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateMembershipDto} updateMembershipDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipControllerUpdate(id, updateMembershipDto, options) {
            return localVarFp
                .membershipControllerUpdate(id, updateMembershipDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * MembershipsApi - object-oriented interface
 * @export
 * @class MembershipsApi
 * @extends {BaseAPI}
 */
export class MembershipsApi extends BaseAPI {
    /**
     *
     * @param {CreateMembershipDto} createMembershipDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    membershipControllerCreate(createMembershipDto, options) {
        return MembershipsApiFp(this.configuration)
            .membershipControllerCreate(createMembershipDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [memberId]
     * @param {'nonMember' | 'currentMember' | 'inactiveMember' | 'removedMember' | 'resignedMember' | 'inReview' | 'pendingApproval' | 'rejected' | 'awaitingUpdate' | 'applicationSent'} [membershipStatus]
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    membershipControllerFindAll(memberId, membershipStatus, page, pageSize, sortBy, options) {
        return MembershipsApiFp(this.configuration)
            .membershipControllerFindAll(memberId, membershipStatus, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    membershipControllerFindOne(id, options) {
        return MembershipsApiFp(this.configuration)
            .membershipControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    membershipControllerRemove(id, options) {
        return MembershipsApiFp(this.configuration)
            .membershipControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {UpdateMembershipDto} updateMembershipDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipsApi
     */
    membershipControllerUpdate(id, updateMembershipDto, options) {
        return MembershipsApiFp(this.configuration)
            .membershipControllerUpdate(id, updateMembershipDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
